import { ModalExt } from "@famiprog-foundation/semantic-ui-react-ext";
import { Button, Modal } from "semantic-ui-react";
import StringFieldRenderer from "../entity_crud/fieldRenderers/StringFieldRenderer";
import { FieldRendererProps } from "../entity_crud/fieldRenderersEditors";
import { ReportDescriptorMaterializer } from "./ReportDescriptorMaterializer";
import { ReportDescriptorMaterializers } from "./ReportDescriptorMaterializers";

export class ParamJsonFieldRenderer extends StringFieldRenderer<FieldRendererProps, { modalOpen: boolean }> {
    
    constructor(props: FieldRendererProps) {
        super(props);
        this.state = { modalOpen: false };
    }

    protected getStopPropagationFunction() {
        return (event: MouseEvent) => { event.stopPropagation(); };
    }

    render() {
        const bt = this.props.entity;
        const report: ReportDescriptorMaterializer = ReportDescriptorMaterializers.INSTANCE.getRegistry()[bt.reportIdAndSubId];                                       
        return report ? <>
            <Button icon="eye" compact onClick={() => this.setState({ modalOpen: true })} />
            <ModalExt open={this.state.modalOpen} closeOnDocumentClick onClose={() => this.setState({ modalOpen: false })} size='tiny'
                modalDimmerProps={{ onDoubleClick: this.getStopPropagationFunction(), onContextMenu: this.getStopPropagationFunction() }}>
                <Modal.Content>
                    {report.renderParamEditorProperties(JSON.parse(bt.paramJson))}
                </Modal.Content>
                <Modal.Actions>
                    <Button positive onClick={() => this.setState({ modalOpen: false })}>{_msg("general.close")}</Button>
                </Modal.Actions>
            </ModalExt>
        </> : <></>
    }
}

export default ParamJsonFieldRenderer;
